import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.number.is-nan.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.number.is-finite.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.slice.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.number.is-nan.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.number.is-finite.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.slice.js";
/**
 *
 * @param formula 公式
 * @param data    数据对象
 */
export function calcFormula(_ref) {
  var formula = _ref.formula,
    data = _ref.data,
    format = _ref.format;
  var infix = formula.replace(/\s/g, ''); // 去除公式空格
  if (Array.isArray(data)) {
    if (format) {
      data = data.reduce(format, {});
    } else {
      return console.error('参数不正确');
    }
  }
  // 1. 中缀表达式转后缀表达式
  var postfix = infixToPostFix(infix, []);

  // 2. 计算后缀表达式
  var res = calcPostFix(postfix, data);
  if (Number.isNaN(res) || res === 'NaN') {
    return '';
  }
  return res;
}
/**
 * 中缀表达式公式转换为后缀表达式
 *
 * @param {string} infix
 * @param {arr} postfix
 */
function infixToPostFix(infix, postfix) {
  var postfixHelper = Stack();
  for (var i = 0; i < infix.length; i++) {
    var c = infix[i];
    if (!isOper(c)) {
      // 处理操作数
      var operands = '';
      while (i < infix.length && !isOper(infix[i])) {
        operands += infix[i++];
      }
      postfix.push(operands);
      i--;
    } else {
      // 处理操作符做出处理
      handlerSymbol(c, postfixHelper, postfix);
    }
  }
  // 如果输入结束，将栈内元素全部弹出，加入后缀表达式中
  while (!postfixHelper.empty()) {
    var _c = postfixHelper.top();
    postfix.push(_c);
    postfixHelper.pop();
  }
  return postfix;
}

// 计算后缀表达式
function calcPostFix(postfix, data) {
  var helperStack = Stack();
  for (var i = 0; i < postfix.length; i++) {
    var c = postfix[i];

    // 如果是操作数，压入栈中
    if (!isOper(c)) {
      var op = formatData(c, data);
      helperStack.push(op);
    } else {
      // 如果是操作符，从栈中弹出元素进行计算
      var op1 = helperStack.top();
      helperStack.pop();
      var op2 = helperStack.top();
      helperStack.pop();
      if (op1 === null || op2 === null) {
        helperStack.push(null);
      } else {
        switch (c) {
          case '+':
            helperStack.push(op2 + op1);
            break;
          case '-':
            helperStack.push(op2 - op1);
            break;
          case '*':
            helperStack.push(op2 * op1);
            break;
          case '/':
            helperStack.push(op2 / op1); // 注意是op2(op)op1而不是op1(op)op2
            break;
        }
      }
    }
  }
  return helperStack.top();
}

/**
 * 处理自定义公式操作数
 * 对于字符串：根据规则获取数据库字段
 * 对于数字：直接返回
 * @param {} param0
 */
function formatData(opRaw, data) {
  var op = opRaw.trim();
  if (Number.isFinite(Number(op))) {
    return Number(op);
  } else if (op.match(/{s\|[\w_]+}/g)) {
    var tmp = op.match(/{s\|([\w_]+)}/)[1];
    return Number(data[tmp]);
  } else if (op.match(/{c\|[\w_]+}/g)) {
    var _tmp = op.match(/{c\|([\w_]+)}/)[1];
    return Number(data[_tmp]);
  }
}
function Stack() {
  var arr = [];
  var push = function push(val) {
    arr.push(val);
  };
  var pop = function pop() {
    arr = arr.slice(0, arr.length - 1);
  };
  var top = function top() {
    if (arr.length === 0) return null;else return arr[arr.length - 1];
  };
  var empty = function empty() {
    return arr.length === 0;
  };
  return {
    push: push,
    pop: pop,
    top: top,
    empty: empty,
    arr: arr
  };
}
function isBracket(c) {
  return c === '(' || c === ')';
}
function isOper(c) {
  return c === '(' || c === ')' || c === '+' || c === '-' || c === '*' || c === '/';
}
function getPriority(oper) {
  switch (oper) {
    case '+':
    case '-':
      return 0;
    case '*':
    case '/':
      return 1;
    case '(':
    case ')':
      return -1;
    default:
      return -2;
  }
}
function handlerSymbol(c, postfixHelper, postfix) {
  if (postfixHelper.empty()) {
    postfixHelper.push(c);
    return;
  }
  if (isBracket(c)) {
    if (c === '(') postfixHelper.push(c);else {
      // 弹出所有元素直到遇到左括号
      while (postfixHelper.top() !== '(') {
        var ch = postfixHelper.top();
        postfix.push(ch);
        postfixHelper.pop();
      }
      // 当遇到左括号时，弹出但不加入postfix(后缀表达式中）
      postfixHelper.pop();
    }
  } else {
    // 如果不是括号
    // 取出栈顶元素，与当前符号进行优先性比较
    var sym = postfixHelper.top();
    // 比较两符号的优先性
    if (getPriority(c) <= getPriority(sym)) {
      // 如果c的优先性比栈顶符号小或等于，弹出栈顶元素
      postfixHelper.pop();
      // 并将其压入postfix（后缀表达式）中
      postfix.push(sym);
      // 递归调用handler,比较当前符号c与下一个栈顶符号的优先性
      handlerSymbol(c, postfixHelper, postfix);
    } else {
      // 如果c比栈顶符号优先级大，那将c压入coll2(操作符栈）中
      postfixHelper.push(c);
    }
  }
}